import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router";

import { UserSelectors } from "../../../store/user";

const ProtectedRoute = ({
  component: Component,
  redirectTo,
  isEnabled,
  setThirdMenuItems,
  ...rest
}) => {
  const user = useSelector(UserSelectors.getUser);

  return (
    <Route
      {...rest}
      render={props =>
        isEnabled({ user }) ? (
          <Component setThirdMenuItems={setThirdMenuItems} {...props} />
        ) : (
          <Redirect to={redirectTo} />
        )
      }
    />
  );
};

ProtectedRoute.propTypes = {
  component: PropTypes.elementType,
  redirectTo: PropTypes.string,
  isEnabled: PropTypes.func,
  setThirdMenuItems: PropTypes.func,
};

export default ProtectedRoute;
